module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackIt.815c95c.woff";